import React from 'react';
import { connect } from 'react-redux';
import { states } from '@/constants/lifecycle';
import ToggleCell from '@/components/table/ToggleCell';
import { toggleUserSearchable } from '../actions';

const UserSearchableCell = ({
  category,
  user,
  onToggleSearchable,
  disabled,
}) => (
  <ToggleCell
    className="aridhia-user-searchable-cell"
    checked={user.searchable}
    disabled={disabled}
    id={`aridhia-user-searchable-cell-${user.uuid}`}
    label={user.name}
    onClick={() => onToggleSearchable(category, user.code)}
  />
);

const mapStateToProps = ({
  auth: { role: { permissions: { users: { update } } } },
}, { user }) => ({
  disabled: user.archived || user.updateStatus === states.PENDING || !update,
});

const mapDispatchToProps = {
  onToggleSearchable: toggleUserSearchable,
};

export default connect(mapStateToProps, mapDispatchToProps)(UserSearchableCell);
